import React, { useMemo, useState,useEffect } from 'react';
import CommonSEOTitle from '../../../../helpers/CommonSEOTitle';
import AccountNavigation from '../Navigation/AccountNavigation';
import { useGetDepartmentDesignation } from '@hooks';
import { getStoredDataUsingKey } from '../../../../helpers/localStorageHelper';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { TNTable } from '../../../../common/components';
import { useGetProfile } from '@hooks';
import { setPageMoveToFirstPage } from '../../../../helpers';
import { onDefaultError } from '../../../../helpers/commonHelpers';

const DepartmentDesignation = ({ t }) => {
  const storageKey = 'my-department-designation';
  const [currentPage, setCurrentPage] = useState(
    getStoredDataUsingKey(storageKey, 'currentPage', 1)
  );
  const [paginationData, setPaginationData] = useState(null);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [profileData, setProfileData] = useState([]);

  const { isLoading: isLoadingProfile } = useGetProfile(
    ({ data: profile }) => {
      if (profile) {
        setProfileData(profile);
      }
    },
    (error) => {
        onDefaultError(error);
    }
  );

    useEffect(() => {
        if(profileData?.user_type && profileData?.user_type != 2){
            navigate(`/my-profile`);
        }
    },[profileData]);
    
    const { refetch } = useGetDepartmentDesignation(
        [currentPage],
        (res) => {if (res.data.user_department_and_designation_list.length === 0 && currentPage > 1) {
        setPageMoveToFirstPage(setCurrentPage, storageKey);
      }
      setData(res.data.user_department_and_designation_list);
      setPaginationData(res.data.pagination);
    },
    (error) => {
        onDefaultError(error);
    }
  );

  const columnsjson = [
    {
      Header: `${t('page.view_user_department_name')}`,
      accessor: 'department_data.department',
      disableSortBy: true
    },
    {
      Header: `${t('page.view_user_designation')}`,
      accessor: 'designation',
      disableSortBy: true
    },
    {
      Header: `${t('page.view_user_start_date')}`,
      accessor: 'formatted_start_date',
      disableSortBy: true
    },
    {
      Header: `${t('page.view_user_end_date')}`,
      accessor: 'formatted_end_date',
      disableSortBy: true
    }
  ];
  const columns = useMemo(() => columnsjson, []);
  if (paginationData === null) {
    return null;
  }

  // Page Index Handler
  const pageIndexHandle = (pageIndex) => {
    setCurrentPage(pageIndex + 1);
  };

  return (
    <>
      {profileData && Object.keys(profileData).length > 0 ? (
        <>
          <CommonSEOTitle title={t('page.department_designation')} />
          {/* Navigation */}
          <AccountNavigation
            t={t}
            formatted_joining_date={profileData?.formatted_joining_date}
            formatted_last_working_date={profileData?.formatted_last_working_date}
            data={profileData}
          />

          <div style={{ clear: 'both', marginTop: '20px' }}>
            <TNTable
              columns={columns}
              data={data}
              paginationData={paginationData}
              onSelectPage={pageIndexHandle}
              t={t}
              pageIndexGet={currentPage - 1}
              key={Math.floor(Math.random() * (1000 - 1 + 1) + 1)}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default DepartmentDesignation;
